<template>
  <div class="gyzhmain">
    <!-- 大图 -->
    <div class="bigbgi">
      <div class="midbgi">
      </div>
    </div>
    <div class="gyzgcont">

      <el-row>
        <el-col :span="5">
          <div class="cdtitle">数据中心</div>
          <el-menu @select="handleSelect" :default-active="pageNum" class="gyzhcd  el-menu-vertical-demo" text-color="#000" active-text-color="#1D50A2">
            <el-menu-item index="1">展馆平面图</el-menu-item>
            <el-menu-item index="2">展位图</el-menu-item>
            <el-menu-item index="3" @click="zszmcx" v-if="false">展商名录</el-menu-item>
            <el-menu-item index="4" v-if="false">电子会刊</el-menu-item>
            <el-menu-item index="5" v-if="false">历届电子会刊</el-menu-item>
          </el-menu>
          <!-- 展出时间 -->
          <div class="zcsj">
            展出时间
          </div>
          <div>
            <div class="rqys">
              <div class="greendian"></div>
              <div class="rcsj">
                2026年6月2日 9:00-17:00
              </div>
            </div>
            <div class="rqys">
              <div class="greendian"></div>
              <div class="rcsj">
                2026年6月3日 9:00-17:00
              </div>
            </div>
            <div class="rqys">
              <div class="greendian"></div>
              <div class="rcsj">
                2026年6月4日 9:00-16:00
              </div>
            </div>
            <div style="margin-bottom:30px" class="rcsj">
              （每日闭馆前1小时停止入场）
            </div>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="bread">
            <div>
              <a href="https://www.ciepec-online.com:8086/"> 首页>>></a>
            </div>
            <div>数据中心>>></div>
            <div>{{menuName}}</div>
          </div>
          <div style="padding:0 30px" v-if="menuName=='展馆平面图'||pageNum==1">
            <img height="900px" style="width:100%" src="../../assets/index/1.jpg" alt="">
          </div>
          <div style="padding:0 30px" v-if="menuName=='展位图'||pageNum==2">
            <div class="zhzl">展位图内容正在建设中...</div>
          </div>
          <div style="padding:0 30px" v-if="menuName=='展商名录'||pageNum==3">
            <div class="zhzl">展商名录内容正在建设中...</div>
          </div>
          <div style="padding:0 30px" v-if="menuName=='电子会刊'||pageNum==4">
            <div class="journal-container">
              <div class="journal-cover">
                <img src="../../../static/20260620/past/第二十四届.png" alt="第二十四届中国国际环保展览会电子会刊">
              </div>
              <div class="journal-info">
                <h3>第二十四届中国国际环保展览会电子会刊</h3>
                <a href="static/20260620/past/24.pdf" target="_blank" class="preview-btn">在线预览</a>
              </div>
            </div>
          </div>
          <div style="padding:0 30px" v-if="menuName=='历届电子会刊'||pageNum==5">
            <div class="past-journals-container">
              <div class="journal-item">
                <img src="../../../static/20260620/past/第二十三届.png" alt="第二十三届中国国际环保展览会电子会刊">
                <div class="journal-name">第二十三届中国国际环保展览会电子会刊</div>
                <a href="static/20260620/past/23.pdf" target="_blank" class="preview-btn">在线预览</a>
              </div>
              <div class="journal-item">
                <img src="../../../static/20260620/past/第二十二届.png" alt="第二十二届中国国际环保展览会电子会刊">
                <div class="journal-name">第二十二届中国国际环保展览会电子会刊</div>
                <a href="static/20260620/past/22.pdf" target="_blank" class="preview-btn">在线预览</a>
              </div>
              <div class="journal-item">
                <img src="../../../static/20260620/past/第二十一届.png" alt="第二十一届中国国际环保展览会电子会刊">
                <div class="journal-name">第二十一届中国国际环保展览会电子会刊</div>
                <a href="static/20260620/past/21.pdf" target="_blank" class="preview-btn">在线预览</a>
              </div>
              <div class="journal-item">
                <img src="../../../static/20260620/past/第十九届.png" alt="第十九届中国国际环保展览会电子会刊">
                <div class="journal-name">第十九届中国国际环保展览会电子会刊</div>
                <a href="static/20260620/past/19.pdf" target="_blank" class="preview-btn">在线预览</a>
              </div>
              <div class="journal-item">
                <img src="../../../static/20260620/past/第十八届.png" alt="第十八届中国国际环保展览会电子会刊">
                <div class="journal-name">第十八届中国国际环保展览会电子会刊</div>
                <a href="static/20260620/past/18.pdf" target="_blank" class="preview-btn">在线预览</a>
              </div>
              <div class="journal-item">
                <img src="../../../static/20260620/past/第十七届.png" alt="第十七届中国国际环保展览会电子会刊">
                <div class="journal-name">第十七届中国国际环保展览会电子会刊</div>
                <a href="static/20260620/past/17.pdf" target="_blank" class="preview-btn">在线预览</a>
              </div>
              <div class="journal-item">
                <img src="../../../static/20260620/past/第十六届.png" alt="第十六届中国国际环保展览会电子会刊">
                <div class="journal-name">第十六届中国国际环保展览会电子会刊</div>
                <a href="static/20260620/past/16.pdf" target="_blank" class="preview-btn">在线预览</a>
              </div>
              <div class="journal-item">
                <img src="../../../static/20260620/past/第十五届.png" alt="第十五届中国国际环保展览会电子会刊">
                <div class="journal-name">第十五届中国国际环保展览会电子会刊</div>
                <a href="static/20260620/past/15.pdf" target="_blank" class="preview-btn">在线预览</a>
              </div>
              <div class="journal-item">
                <img src="../../../static/20260620/past/第十四届.png" alt="第十四届中国国际环保展览会电子会刊">
                <div class="journal-name">第十四届中国国际环保展览会电子会刊</div>
                <a href="static/20260620/past/14.pdf" target="_blank" class="preview-btn">在线预览</a>
              </div>
              <div class="journal-item">
                <img src="../../../static/20260620/past/第十三届.png" alt="第十三届中国国际环保展览会电子会刊">
                <div class="journal-name">第十三届中国国际环保展览会电子会刊</div>
                <a href="static/20260620/past/13.pdf" target="_blank" class="preview-btn">在线预览</a>
              </div>
              <div class="journal-item">
                <img src="../../../static/20260620/past/第十二届.png" alt="第十二届中国国际环保展览会电子会刊">
                <div class="journal-name">第十二届中国国际环保展览会电子会刊</div>
                <a href="static/20260620/past/12.pdf" target="_blank" class="preview-btn">在线预览</a>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Sjzx',
  data () {
    return {
      menuName: '展馆平面图',
      pageNum: '1'
    }
  },
  methods: {
    handleSelect (key) {
      this.menuName = event.target.innerText.trim()
      this.pageNum = key
    },
    zszmcx () {
      window.location.href = 'https://www.ciepec-online.com/'
    }
  }
}
</script>

<style scoped>
.gyzhmain {
  width: 100%;
}
.bigbgi {
  background-image: url('../../assets/index/banner-2026.jpg');
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
  width: 100%;
  height: 0;
  padding-bottom: 27.87%;
  margin-bottom: 60px;
}
.midbgi {
  background-image: none;
  width: 100%;
}
.gyzgcont {
  width: 80%;
  margin: 0 auto;
}

.gyzhcd {
  background: url('../../assets/index/cebian2.png') no-repeat,
    linear-gradient(180deg, #ffffff 0%, #e4efff 100%);
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: 100%;

  width: 100%;
}
.el-menu-item {
  text-align: center;
  font-size: 18px;
  color: #16181a;
  letter-spacing: -0px;
  text-align: center;
  font-weight: 400;
}
.el-menu-item.is-active {
  font-weight: bold;
  color: #1d50a2;
}
.cdtitle {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -80px;
  height: 86px;
  color: #fff;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 700;
  background-image: url('../../assets/index/cebian1.png'); /* 设置图片路径 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center; /* 背景图片居中 */
  background-size: cover;
  height: 80px; /* 元素高度 */
}
.bread {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -60px;
  opacity: 0.94;
  background-image: linear-gradient(
    90deg,
    rgba(14, 152, 121, 0) 0%,
    #0e9577 50%
  );
  height: 60px;
  width: 470px;
  float: right;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 500;
}

a {
  text-decoration: none;
  font-size: 16px;
  color: #fff;
}
.zcsj {
  margin: 20px 0;
  padding: 10px 0;
  background: #159a7e;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
  font-weight: 600;
}
.rqys {
  display: flex;
  align-items: center;
  height: 40px;
}
.greendian {
  width: 10px;
  height: 10px;
  border-radius: 10px;
  background: #159a7e;
}
.rcsj {
  flex: 1;
  font-size: 18px;
  color: #333333;
  text-align: center;
  line-height: 18px;
  font-weight: 400;
}
.zhzl {
  font-size: 18px;
  font-weight: normal;
  margin: 0 30px;
  line-height: 45px;
}
.journal-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 50px 0;
}
.journal-cover {
  margin-bottom: 30px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  background: #fff;
  padding: 20px;
  max-width: 100%;
}
.journal-cover img {
  max-width: 100%;
  max-height: 600px;
  object-fit: contain;
}
.journal-info {
  text-align: center;
}
.journal-info h3 {
  font-size: 24px;
  color: #1d50a2;
  margin-bottom: 20px;
}
.preview-btn {
  display: inline-block;
  padding: 10px 30px;
  background-color: #159a7e;
  color: #fff;
  text-decoration: none;
  border-radius: 4px;
  font-size: 16px;
  transition: background-color 0.3s;
}
.preview-btn:hover {
  background-color: #0e7a64;
}
.past-journals-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 30px;
  padding: 20px 0;
}
.journal-item {
  text-align: center;
  border: 1px solid #e0e0e0;
  padding: 15px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  background: #fff;
}
.journal-item img {
  width: 100%;
  max-height: 350px;
  object-fit: contain;
  margin-bottom: 15px;
}
.journal-name {
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/caidan/sjzx.vue